// api
import ModelService from '@/services/model.service'
import { mapState } from 'vuex'

export default {
  name: 'Operations',
  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      adIdList: [7, 18, 45, 63, 80],
      // data
      factoryPos: ['EVH', 'EVZ', 'EVN', 'EVM', 'EVC', 'PRB', 'PBB','EVI'],
      mobileCurData: '',
      mobileStatus: false,
      mobilePicStatus: false,
      curPicturnUrl: '',
      swiperSlides: '',
      factoryList: '',
      galleryParams: [
        {
          param: {
            factoryName: 'EVN'
          },
          query: {
            sid: 512,
          },
          award: {
            sid: 513,
          },
        },
        {
          param: {
            factoryName: 'EVH'
          },
          query: {
            sid: 517,
          },
          award: {
            sid: 518,
          },
        },
        {
          param: {
            factoryName: 'EVM'
          },
          query: {
            sid: 526,
          },
          award: {
            sid: 527,
          },
        },
        {
          param: {
            factoryName: 'EVC'
          },
          query: {
            sid: 534,
          },
          award: {
            sid: 535,
          },
        },
        {
          param: {
            factoryName: 'PRB'
          },
          query: {
            sid: 537,
          },
          award: {
            sid: 538,
          },
        },
        {
          param: {
            factoryName: 'PBB'
          },
          query: {
            sid: 544,
          },
          award: {
            sid: 545,
          },
        },
        {
          param: {
            factoryName: 'EVI'
          },
          query: {
            sid: 4238,
          },
          award: {
            sid: 4239,
          },
        },
      ],
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 'auto',
        freeMode: true,
        scrollbar: {
          el: '.swiper-scrollbar'
        },
        mousewheel: true
      },
      milestoneOption: {
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: true,
      },
      pageName: '',
      pageName_cn: {
        detail: '查看更多',
        certificate: '证书',
        award: '荣获奖项',
        adress: '公司地址',
      },
      pageName_en: {
        detail: 'Detail',
        certificate: 'Certificate',
        award: 'Award',
        adress: 'Factory Adress',
      },
    };
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex'])
  }),
  watch: {
    LangIndex: {
      handler(str) {
        this.init();
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getAdPictureList();
      this.getFactoryList();
      this.initLang();
    },
    initLang() {
      if (this.LangIndex === 1) {
        this.pageName = this.pageName_cn;
      } else {
        this.pageName = this.pageName_en;
      };
    },
    // 根据工厂列表
    getFactoryList() {
      const language = {
        lang: this.language
      };
      ModelService.getFactoryList(language).then((res) => {
        if (res.code === 0) {
          this.factoryList = this.even(res.data);
          // console.log('getFactoryList: ', res.data);
        }
      });
    },
    // 根据id获取广告图片
    getAdPictureList() {
      const param = {
        lang: this.language,
        adId: this.adIdList[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.swiperSlides = res.data[0];
        }
      });
    },
    // 清洗数据 分解字符串
    split(str) {
      return str.split(';');
    },
    // 清洗数据
    even(arr) {
      arr.forEach(item => {
        item.status = false;
      });
      return arr;
    },
    // 数据过滤
    evenGallery(numbers, target) {
      return numbers.filter( (number) => {
        return number.param.factoryName === target
      })
    },
    // 跳转对应相册
    goGalleryPage(name, tatget) {
      const urls = this.evenGallery(this.galleryParams, name)[0];
      this.$tools.go({
        name: 'Gallery',
        params: urls.param,
        query: urls[tatget],
      });
    },
    openLayer(index) {
      let data = this.even(this.factoryList);
      data[index].status = true;
      this.mobileCurData = data[index];
      this.mobileStatus = true;
      this.factoryList = data;
    },
    closeLayer(index) {
      let data = this.factoryList;
      data[index].status = false;
      this.mobileStatus = false;
      this.factoryList = data;
    },
    closeMobileLayer() {
      this.mobileStatus = false;
    },
    openPicLayer(url) {
      this.curPicturnUrl = url;
      this.mobilePicStatus = true;
    },
    closePicLayer() {
      this.mobilePicStatus = false;
    },
  },
};
